<template>
  <div class="main success">
    <div class="part1 blue">
      <div>{{ $t('prices-success-title1') }}</div>
      <div class="title">{{ $t('prices-success-title2') }}</div>
    </div>
    <div class="part2">{{ $t('prices-success-title3') }}：<span class="blue">{{ account }}</span></div>
    <div class="part3">{{ $t('prices-success-title4') }}：<span class="blue">{{ paymentPlan }}</span></div>
  </div>
</template>
<script>
//  import state from '../../assets/js/state'
  export default {
    data () {
      return {
        account: '',
        paymentPlan: ''
      }
    },
    mounted () {
//      console.log(this.$router)
//      this.account = state.getData().account
//      this.paymentPlan = state.getData().paymentPlan
      this.account = this.$router.history.current.query.account
      this.paymentPlan = this.$router.history.current.query.product_name
    }
  }
</script>

<style lang="scss" scoped>
  .success {
    font-size: 0.3rem !important;
    line-height: .6rem;
    width: 7rem;
    margin: 2.28rem auto 4.3rem !important;
    @media screen and (max-width: 760px){
      font-size: 0.2rem !important;
      width: 3rem;
      margin: 1.28rem auto 3.26rem !important;
      line-height: .4rem;
    }
    .blue {
      color: #00a7ff;
    }
    .part1 {
      line-height: .3rem;
      .title {
        line-height: .4rem;
        font-size: .15rem;
        @media screen and (max-width: 760px){
          line-height: .3rem;
        }
      }
    }
    .part2 {
      margin-top: .4rem;
      @media screen and (max-width: 760px){
        font-size: .16rem;
      }
    }
    .part3 {
      @media screen and (max-width: 760px){
        margin-top: .2rem;
        font-size: .16rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Success.vue?43628f22